function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  fill: "rgb(206, 206, 206)",
  d: "M17.383,3.542 L11.931,8.998 L17.383,14.454 C18.194,15.266 18.194,16.581 17.383,17.393 C16.978,17.798 16.447,18.001 15.916,18.001 C15.384,18.001 14.853,17.798 14.448,17.393 L8.995,11.936 L3.542,17.393 C3.137,17.798 2.606,18.001 2.075,18.001 C1.543,18.001 1.013,17.798 0.607,17.393 C-0.204,16.582 -0.204,15.266 0.607,14.454 L6.059,8.998 L0.607,3.542 C-0.204,2.731 -0.204,1.416 0.607,0.604 C1.418,-0.207 2.731,-0.207 3.542,0.604 L8.995,6.060 L14.447,0.604 C15.258,-0.207 16.572,-0.207 17.383,0.604 C18.194,1.416 18.194,2.731 17.383,3.542 Z"
});

var SvgX = function SvgX(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgX, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/x.e2ce8e16.svg";
export { ForwardRef as ReactComponent };